/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = (props) => {
    
    const { icon } = props;
    if (!icon) {
        return null;
    } else {
        // console.log(`icon: ${icon}`)
        return (
            <Fragment>
                {icon &&
                    <FontAwesomeIcon icon={`fa-solid ${icon}`} size={"2x"}/>
                }
            </Fragment>
        );
    }
};

export { Icon };
